export const modules = [
    {
        semester: "AY2022/2023 Semester 1",
        modules: [
            "CS1101S Programming Methodology",
            "CS1231 Discrete Structures",
            "MA2001 Linear Algebra I",
            "BSP1702 Legal Environment of Business",
            "BSP1703 Managerial Economics",
            "IS1108 Digital Ethics and Data Privacy",
            "BPM1705 Understanding How Business Works",
        ],
    },
    {
        semester: "AY2022/2023 Semester 2",
        modules: [
            "CS2040S Data Structures and Algorithms",
            "CS2030S Programming Methodology II",
            "GEA1000 Quantitative Reasoning with Data",
            "MA1521 Calculus for Computing",
            "MKT1705 Principles of Marketing",
            "MNO1706 Organisational Behaviour",
            "ACC1701 Accounting for Decision Makers",
        ],
    },
    {
        semester: "AY2023/2024 Semester 1",
        modules: [
            "CS2100 Computer Organisation",
            "CS2103T Software Engineering",
            "CS2109S Introduction to AI and Machine Learning",
            "ES2660 Communicating in the Information Age",
            "CP2106 Independent Software Development Project (Orbital)",
            "CS2101 Effective Communication for Computing Professionals",
            "MNO2705 Leadership and Decision Making Under Uncertainty",
            "BPM1701 Calculus and Statistics",
            "BPM1702 Microsoft Excel and Powerpoint for Business",
        ],
    },
    {
        semester: "AY2023/2024 Semester 2",
        modules: [
            "CS2105 Introduction to Computer Networks",
            "CS3217 Software Engineering on Modern Application Platforms",
            "ST2334 Probability and Statistics",
            "FIN2704 Finance",
            "BSP2701 Global Economy",
            "GESS1029 Everyday Ethics in Singapore",
        ],
    },
    {
        semester: "AY2024/2025 Semester 1",
        modules: ["Went for NOC, interned in Paris for 5 months"],
    },
    {
        semester: "AY2024/2025 Semester 2",
        modules: [
            "CS2106 Operating Systems",
            "CS3230 Algorithm Design and Analysis",
            "CS4248 Natural Language Processing",
            "FIN3702 Investment Analysis and Portfolio Management",
            "FIN3703 Financial Management",
            "HSI2009 What is a Planet?",
        ],
    },
    {
        semester: "AY2025/2026 Semester 1",
        modules: [
            "FIN3701 Corporate Finance",
            "DAO2703 Operations and Technology Management",
            "CS4243 Computer Vision and Pattern Recognition",
            "CS3210 Parallel Computing",
            "GEN2050 Teach SG",
            "CS2102 Database Systems",
            "CS3264 Foundations of Machine Learning",
        ],
    },
    {
        semester: "AY2025/2026 Semester 2",
        modules: [
            "CS4215 Programming Language Implementation",
            "FIN3712 Options and Futures",
            "FIN4717 Entrepreneurial Finance",
            "HSI2011 The World of Quantum",
            "BSP3701 Strategic Management",
            "HSH1000 The Human Condition",
            "GEC1007 Geopolitics: Geographies of War & Peace",
        ],
    },
];
